<div cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <modal-header-default></modal-header-default>
  @if (!isVerificationPending()) {
    <div class="modal-add-info mb-30 content">
      <h3 class="modal-add-info-headline">
        {{ "because_of_verification_you_cant_use_deposit_header" | translate }}
      </h3>
      <p class="modal-add-info-text text-narrowest center-block">
        {{ "modal_unverified_deposit" | translate }}
      </p>
      <button
        class="modal-add-info-button btn btn-primary btn-inverse btn-bold btn-bigger-text"
        (click)="verify()"
        type="button">
        <i class="bpi__icon-verify"></i>
        {{ "start_verification_here_button" | translate }}
      </button>
    </div>
  } @else {
    <div class="modal-add-info mb-30 pt-20 content">
      <h3 class="modal-add-info-headline">
        {{ "modal_verification_progress_title" | translate }}
      </h3>
      <p class="modal-add-info-text text-narrow center-block">
        {{ "modal_verification_progress_info" | translate }}
      </p>
    </div>
  }
</div>
